import { render, staticRenderFns } from "./PictureBox.vue?vue&type=template&id=165af807&scoped=true&"
import script from "./PictureBox.vue?vue&type=script&lang=js&"
export * from "./PictureBox.vue?vue&type=script&lang=js&"
import style0 from "./PictureBox.vue?vue&type=style&index=0&id=165af807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165af807",
  null
  
)

export default component.exports